"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Icon = _interopRequireDefault(require("../ImagesAndIcons/Icon"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const LinkIcon = _styledComponents.default.div.withConfig({
  displayName: "LinkListItem__LinkIcon",
  componentId: "design-system__sc-1f5bhfm-0"
})(["svg{display:block;}"]);

const StyledLink = (0, _styledComponents.css)(["font-family:", ";font-size:", ";line-height:100%;color:", ";cursor:", ";text-decoration:none;&:hover{text-decoration:", ";}"], _BaseTheme.default.type.family.system, _BaseTheme.default.type.size.small, props => props.disabled ? '#B4B4B4' : _BaseTheme.default.colors.blue, props => props.disabled ? 'not-allowed' : 'pointer', props => props.disabled ? 'none' : 'underline');
const StyledReactRouterDomLink = (0, _styledComponents.default)(_reactRouterDom.Link).withConfig({
  displayName: "LinkListItem__StyledReactRouterDomLink",
  componentId: "design-system__sc-1f5bhfm-1"
})(["", ";"], StyledLink);

const StyledRegularLink = _styledComponents.default.a.withConfig({
  displayName: "LinkListItem__StyledRegularLink",
  componentId: "design-system__sc-1f5bhfm-2"
})(["", ";"], StyledLink);

const StyledDisabledLink = _styledComponents.default.span.withConfig({
  displayName: "LinkListItem__StyledDisabledLink",
  componentId: "design-system__sc-1f5bhfm-3"
})(["", ""], StyledLink);

const renderIcon = linkIcon => /*#__PURE__*/_react.default.createElement(LinkIcon, {
  className: "link-icon"
}, /*#__PURE__*/_react.default.createElement(_Icon.default, {
  type: linkIcon,
  size: "16"
}));

const renderLink = (children, to, onClick, disabled) => {
  if (disabled) {
    return /*#__PURE__*/_react.default.createElement(StyledDisabledLink, {
      disabled: true
    }, children);
  }

  if (to) {
    return /*#__PURE__*/_react.default.createElement(StyledReactRouterDomLink, {
      to: to,
      type: "small"
    }, children);
  }

  return /*#__PURE__*/_react.default.createElement(StyledRegularLink, {
    href: "#",
    onClick: onClick,
    type: "small",
    disabled: disabled
  }, children);
};

const LinkListItem = _ref => {
  let {
    to,
    children,
    linkIcon,
    onClick,
    disabled
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("li", null, linkIcon && renderIcon(linkIcon), renderLink(children, to, onClick, disabled));
};

LinkListItem.propTypes = {
  to: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object, _propTypes.default.func]),
  children: _propTypes.default.string.isRequired,
  linkIcon: _propTypes.default.string,
  onClick: _propTypes.default.func,
  disabled: _propTypes.default.bool
};
LinkListItem.defaultProps = {
  to: undefined,
  linkIcon: undefined,
  disabled: false,
  onClick: () => {}
};
var _default = LinkListItem;
exports.default = _default;